import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import React from 'react';
import { Step2Tabs } from '../../enums/step-2-tabs';

/**
 * Cart Step 2 Tabs
 */
const CartStep2Tabs = () => {
    const dispatch = useAppDispatch();
    const step2Tab = useAppSelector(store => store.root.step2Tab);
    const selectedClasses = 'font-bold pb-2 border-b-2 border-gray-700';

    return (
        <div className="text-sm text-black px-6 pt-3 border-b mb-3">
            <button
                type="button"
                className={`pointer mr-6 ${ step2Tab === Step2Tabs.Login ? selectedClasses : '' }`}
                onClick={ evt => {
                    dispatch(
                        rootActions.main({
                            step2Tab: Step2Tabs.Login,
                        })
                    );
                }}>Returning Customer</button>

            <button
                type="button"
                className={`pointer ${ step2Tab === Step2Tabs.CreateAccount ? selectedClasses : '' }`}
                onClick={ evt => {
                    dispatch(
                        rootActions.main({
                            step2Tab: Step2Tabs.CreateAccount,
                        })
                    );
                }}>Guest / New Customer</button>
        </div>
    )
};

export default CartStep2Tabs;